// src/App.js
import React, { useState, useEffect } from 'react';
import { levels } from './data/levels';
import MenuScreen from './components/MenuScreen';
import LevelSelectionScreen from './components/LevelSelectionScreen';
import GameScreen from './components/GameScreen';
import GameOverScreen from './components/GameOverScreen';
import CompletedScreen from './components/CompletedScreen';

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [lives, setLives] = useState(3);
  const [gameState, setGameState] = useState('menu');
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(null);
  const [userProgress, setUserProgress] = useState({});

  // LocalStorage'dan ilerlemeyi yükle
  useEffect(() => {
    const savedProgress = localStorage.getItem('ayselady-progress');
    if (savedProgress) {
      setUserProgress(JSON.parse(savedProgress));
    }
  }, []);

  // İlerlemeyi kaydet
  const saveProgress = (newProgress) => {
    setUserProgress(newProgress);
    localStorage.setItem('ayselady-progress', JSON.stringify(newProgress));
  };

  // Kedi boyutları hesaplama (genel ilerlemeye göre)
  const getCatSize = () => {
    const completedLevels = Object.keys(userProgress).filter(levelId => 
      userProgress[levelId]?.completed
    ).length;
    const progress = (completedLevels / levels.length) * 100;
    
    if (progress < 25) return { size: 60, stage: "Yavru Kedi 🐱" };
    if (progress < 50) return { size: 80, stage: "Genç Kedi 😸" };
    if (progress < 75) return { size: 100, stage: "Yetişkin Kedi 😺" };
    return { size: 120, stage: "Büyük Kedi 😻" };
  };

  // Level seçimi
  const handleSelectLevel = (levelId) => {
    const level = levels.find(l => l.id === levelId);
    setCurrentLevel(level);
    setCurrentQuestion(0);
    setScore(0);
    setLives(3);
    setSelectedAnswer(null);
    setShowResult(false);
    setGameState('playing');
  };

  // Soruyu kontrol et
const handleAnswerSelect = (isCorrect) => {
  setSelectedAnswer(isCorrect ? 1 : 0); // Sadece doğru/yanlış için
  setShowResult(true);
  
  setTimeout(() => {
    if (isCorrect) {
      setScore(prev => prev + 1);
    } else {
      setLives(prev => prev - 1);
    }
    
    setTimeout(() => {
      if (currentQuestion >= currentLevel.questions.length - 1) {
        // Level tamamlandı
        const levelScore = score + (isCorrect ? 1 : 0);
        const isLevelCompleted = levelScore >= 7; // 10 sorudan 7'sini doğru yapması gerek
        
        // İlerlemeyi kaydet
        const newProgress = {
          ...userProgress,
          [currentLevel.id]: {
            completed: isLevelCompleted,
            score: levelScore,
            attempts: (userProgress[currentLevel.id]?.attempts || 0) + 1
          }
        };
        saveProgress(newProgress);
        
        if (isLevelCompleted) {
          setGameState('levelCompleted');
        } else {
          setGameState('levelFailed');
        }
      } else if (lives <= 1 && !isCorrect) {
        setGameState('gameOver');
      } else {
        setCurrentQuestion(prev => prev + 1);
        setSelectedAnswer(null);
        setShowResult(false);
      }
    }, 1500);
  }, 1000);
};

  // Oyunu yeniden başlat
  const handleResetGame = () => {
    if (currentLevel) {
      handleSelectLevel(currentLevel.id);
    }
  };

  // Ana menüye dön
  const handleBackToMenu = () => {
    setGameState('menu');
    setCurrentLevel(null);
  };

  // Level seçime dön
  const handleBackToLevels = () => {
    setGameState('levelSelect');
    setCurrentLevel(null);
  };

  // Level seçim ekranına git
  const handleStartGame = () => {
    setGameState('levelSelect');
  };

  const catInfo = getCatSize();

  // Ekran durumuna göre render
  switch (gameState) {
    case 'menu':
      return <MenuScreen onStartGame={handleStartGame} />;
    
    case 'levelSelect':
      return (
        <LevelSelectionScreen 
          userProgress={userProgress}
          onSelectLevel={handleSelectLevel}
          onBackToMenu={handleBackToMenu}
        />
      );
    
    case 'playing':
      return (
        <GameScreen 
          currentQuestion={currentQuestion}
          questions={currentLevel.questions}
          lives={lives}
          score={score}
          selectedAnswer={selectedAnswer}
          showResult={showResult}
          onAnswerSelect={handleAnswerSelect}
          getCatSize={getCatSize}
          levelTitle={currentLevel.title}
          levelEmoji={currentLevel.emoji}
        />
      );
    
    case 'gameOver':
      return (
        <GameOverScreen 
          score={score}
          catInfo={catInfo}
          onResetGame={handleResetGame}
          onBackToMenu={handleBackToLevels}
          levelTitle={currentLevel.title}
        />
      );
    
    case 'levelCompleted':
      return (
        <CompletedScreen 
          score={score}
          catInfo={catInfo}
          onResetGame={handleResetGame}
          onBackToMenu={handleBackToLevels}
          levelTitle={currentLevel.title}
          isLevelComplete={true}
        />
      );
      
    case 'levelFailed':
      return (
        <GameOverScreen 
          score={score}
          catInfo={catInfo}
          onResetGame={handleResetGame}
          onBackToMenu={handleBackToLevels}
          levelTitle={currentLevel.title}
          message="Level tamamlanamadı! 10 sorudan en az 7'sini doğru yapmalısın."
        />
      );
    
    default:
      return <MenuScreen onStartGame={handleStartGame} />;
  }
}

export default App;